function normalizeUpdateText (text) {
  return text
    .replace(/\r\n?/g, '\n')
    .replace(/\\n/gi, '\n')
    .replace(/\/n/gi, '\n')
    .replace(/（/g, '(')
    .replace(/）/g, ')')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export function formatUpdateSegments (text) {
  if (typeof text !== 'string') return []
  const normalized = normalizeUpdateText(text)
  if (!normalized) return []

  const pattern = /(?:\(?(\d+)[.．。、]\)?\s*)([\s\S]*?)(?=(?:\(?\d+[.．。、]\)?\s*)|$)/g
  const segments = []
  let match

  while ((match = pattern.exec(normalized)) !== null) {
    const order = match[1]
    const content = (match[2] || '').replace(/\s+/g, ' ').trim()
    if (content) segments.push(`${order}. ${content}`)
  }

  if (!segments.length) {
    return normalized
      .split(/\n+/)
      .map(item => item.replace(/\s+/g, ' ').trim())
      .filter(Boolean)
  }
  return segments
}

export function buildUpdateMessage (baseMsg, text) {
  return buildUpdateDialogContent(baseMsg, text).plain
}

function paragraphHtml (content, extraStyle = '') {
  const style = ['margin:0 0 8px', 'line-height:1.6']
  if (extraStyle) style.push(extraStyle)
  return `<p style="${style.join(';')}">${escapeHtml(content)}</p>`
}

function escapeHtml (str = '') {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function buildUpdateDialogContent (baseMsg, text) {
  const normalized = typeof text === 'string' ? normalizeUpdateText(text) : ''
  if (!normalized) {
    return {
      plain: baseMsg,
      html: paragraphHtml(baseMsg)
    }
  }
  const segments = formatUpdateSegments(text)
  if (!segments.length) {
    return {
      plain: `${baseMsg}\n\n${normalized}`,
      html: paragraphHtml(baseMsg) + paragraphHtml(normalized)
    }
  }
  const plain = `${baseMsg}\n更新内容\n${segments.join('\n\n')}`
  const htmlSegments = segments.map(seg => paragraphHtml(seg)).join('')
  const html =
    '<div class="update-dialog">' +
    paragraphHtml(baseMsg, 'margin-top:0;margin-bottom:12px') +
    paragraphHtml('更新内容', 'font-weight:600;margin-bottom:10px') +
    htmlSegments +
    '</div>'
  return { plain, html }
}
